<!--

IMPORTANT:
This file is used only in vue3 applicatoion
Changes made here should be made in vue2 also
Vue2 file: wwwroot\js\components\shared\TotalIncentiveDiscount.vue
For any clarifications contact Leela

-->
<template>
  <div v-if="incentives && incentives.length > 0" :class="component + ' ' + themeName">
    <div class="incentiveBlock ft-13">
      <div class="incentiveText grey-text" :style="{ color: conditionalOfferFontColor }">
        <div v-if="showConditionalRebatesBreakoutIncentives">
          <p v-if="!customHeaderLabel" class="mb-1 conditional_offers_header_label"
            :class="{ 'font-weight-bold': isMazda }">
            <span class="text-capitalize conditional-offers">{{ themeName }}</span> Conditional
            Offers
          </p>
          <p v-else class="mb-1 conditional_offers_header_label" :class="{ 'font-weight-bold': isMazda }">
            <span class="text-capitalize">{{ customHeaderLabel }}</span>
          </p>
          <ul class="list-unstyled mb-0">
            <li v-for="(data, index) in incentives" :key="index" class="d-flex justify-content-between"
              :class="{ 'ford-incentives': isFord }" @click.prevent>
              <div class="position-relative mr-5 conditional_offers_items_label">
                {{ data.programname }}

                <template v-if="showIncentiveDisclaimer(data.programname) && themeName === 'toyota'">
                  <span class="incentive-popover-parent position-relative">
                    <i class="primaryicon-question-circle-o cursor-pointer" />
                    <div id="__bv_popover_656__" role="tooltip" tabindex="-1"
                      class="b-popover bs-popover-bottom popover incentive-popover-class-down-icon"
                      x-placement="bottom">
                      <div class="arrow" style="top: 12px; left: -7px" />
                    </div>

                    <div class="ft-12 incentive-popover-class color-black">
                      <a :href="getIncentiveLink(data.programname)" class="text-underline text-primary"
                        @click="navigateTo(data.programname)">Click here</a>
                      for more information.
                    </div>
                  </span>
                </template>
                <span v-else-if="showDetailsText" class="cursor-pointer ft-11"
                  @click="showFodIncentiveDisclaimerModel(data)">
                  - <span class="text-underline">Details</span>
                </span>
                <i v-else-if="data && data.disclaimer" class="primaryicon-question-circle-o cursor-pointer"
                  @click="showFodIncentiveDisclaimerModel(data)" />
              </div>
              <div class="conditional_offers_items_value">
                {{ showMinusSymbol ? "-" : "" }}${{ convertThousandSeperator(data.cash) }}
              </div>
            </li>
          </ul>
        </div>
        <template v-else>
          <span>
            <span v-if="!customHeaderLabel" class="text-capitalize">
              <span class="conditional-offers">{{ themeName }}</span> Conditional Offers</span>
            <span v-else class="text-capitalize">{{ customHeaderLabel }}</span>
            <i class="incentiveBlockTooltipCond" @click.prevent="onClickConditionalOffers"><i
                class="primaryicon-question-circle-o" />
              <div v-if="showConditionalOffers" class="tooltip">
                <ul>
                  <li v-for="(data, index) in incentives" :key="`${data.incentiveid}-${index}`">
                    <span>{{ data.programname }}s
                      <i v-if="data && data.disclaimer && themeName === 'toyota'"
                        class="primaryicon-question-circle-o cursor-pointer"
                        @click="showFodIncentiveDisclaimerModel(data)" />
                    </span>
                    <span>{{ showMinusSymbol ? "-" : "" }}${{
                      convertThousandSeperator(data.cash)
                    }}</span>
                  </li>
                </ul>
              </div>
            </i>
          </span>
          <!-- fright : Removed this class form below line to algin amount near to label -->
          <span v-if="!hideConditionalRebatesTotal" class="price-value" :class="{
            'mr-2': component === 'payment',
            'ml-2': isFord,
          }">{{ showMinusSymbol ? "-" : "" }}${{ convertThousandSeperator(totalIncentive) }}</span>
        </template>
        <div v-if="showFinalPrice && totalIncentive && type === 'srp' && finalPriceValue"
          class="ft-20 d-flex justify-content-between" :style="{ 'font-weight': finalConditionFontWeight }">
          <span :style="{ color: getFontColorForLabel() }"
            class="grey-text vehiclebox-msrp mr-2 final_conditional_price_label_custom"
            v-html="finalConditionalPriceLabel" />
          <span :style="{ color: getFontColorForLabel() }"
            class="grey-text vehiclebox-msrp final_conditional_price_value_custom" :class="{
              'mr-2': component === 'payment',
              'ml-2': isFord,
              _theme_font_bold: finalConditionFontWeight === 'bold',
            }">${{ convertThousandSeperator(getPriceData) }}</span>
        </div>
        <div v-if="showFinalPrice && totalIncentive && type === 'vdp' && finalPriceValue"
          class="_mitsubishi_font_black d-flex justify-content-between msrp-price-details py-2 w-100 ft-16"
          :style="{ 'font-weight': finalConditionFontWeight }">
          <span :style="getConditionalLabelStyles()" class="final_conditional_price_label_custom"
            v-html="finalConditionalPriceLabel" />
          <span :style="getConditionalLabelStyles()" class="final_conditional_price_value_custom" :class="{
            'mr-2': component === 'payment',
            'ml-2': isFord,
            _theme_font_bold: finalConditionFontWeight === 'bold',
          }">${{ convertThousandSeperator(getPriceData) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useTextModalStore } from "../../../store/Shared/TextModalStore/TextModalStore";
import { mapWritableState } from "pinia";
// import { isFdLincolnDealer, isFordDealer } from "../../services/FordDirect/FordCookieService";
import { useThousandseperator } from "../../../Composables/Thousandseperator/Thousandseperator";
import { usePaymentSettingsStore } from "../../../store/PaymentSettings/PaymentsettingsStore";
import { isFdLincolnDealer, isFordDealer } from "../../../Events/FordDirect/FordCookieService";

export default {
  // setup() {
  //   const { Thousandseperator } = useThousandseperator();
  //   return {
  //     Thousandseperator,
  //   };
  // },
  props: {
    qualifiedData: {
      required: false,
    },
    component: {
      required: false,
      default: "",
      type: String,
    },
    vin: {
      required: false,
      default: "",
      type: String,
    },
    type: {
      required: false,
      default: "vdp",
      type: String,
    },
    showMinusOnConditionalOffers: {
      required: false,
      default: false,
      type: Boolean,
    },
    pricedata: {
      required: false,
      default: {},
      type: Object,
    },
    showfinalconditionalpricesrp: {
      required: false,
      default: false,
      type: Boolean,
    },
    srpcolor: {
      required: false,
      default: "",
      type: String,
    },
    customHeaderLabel: {
      required: false,
      default: "",
      type: String,
    },
  },

  data() {
    return {
      incentives: [],
      themeName: this.getThemeName(),
      isSDISEnabled: window.isSDISEnabled,
      hideConditionalRebatesTotal: window.hideConditionalRebatesTotal || false,
      showConditionalRebatesBreakoutIncentives: false,
      disclaimer: "",
      showDisclaimer: false,
      paymentType: "",
      isFord: isFordDealer(window.themeName),
      conditionalOfferFontColor: window.conditionalOfferFontColor,
      isMazda: window.themeName.toLowerCase().includes("mazda"),
      showConditionalOffers: !(window.ismobile || window.istablet),
      finalConditionalPriceLabel: window.finalConditionalPriceLabel
        ? window.finalConditionalPriceLabel
        : "Final Conditional Price",
      finalConditionFontWeight: window.finalConditionalPriceFontWeight,
      finalPriceValue: "",
      showDetailsText: window.showConditionalIncentiveDetailsText,
      isFdDealer: window.isFdDealer,

    };
  },
  computed: {
    ...mapWritableState(useTextModalStore, ["showTextModal", "title", "text"]),
    ...mapWritableState(usePaymentSettingsStore, ["selectedPaymentOption", "settings"]),

    totalIncentive() {
      if (this.incentives && this.incentives.length) {
        return this.incentives.reduce((accumulator, object) => {
          return accumulator + object.cash;
        }, 0);
      }
      return 0;
    },
    getPriceData() {
      if (!this.pricedata) return;
      return +this.pricedata?.yourPrice ? +this.pricedata?.yourPrice - this.totalIncentive : 0;
    },
    showFinalPrice() {
      return (
        (this.type === "srp" && this.showfinalconditionalpricesrp) ||
        (this.type === "vdp" && window.showFinalConditionalPriceVDP)
      );
    },
    showMinusSymbol() {
      return this.showMinusOnConditionalOffers || this.settings.showMinusOnConditionalOffers;
    },
  },
  watch: {
    pricedata: function (val) {
      if (val) {
        this.finalPriceValue = +this.pricedata?.yourPrice
          ? +this.pricedata?.yourPrice - this.totalIncentive
          : 0;
      } else {
        this.finalPriceValue = 0;
      }
    },
  },
  mounted() {

    this.title = "Disclosure";
    this.paymentType = window.paymentType ? window.paymentType : this.selectedPaymentOption;
    this.showConditionalRebatesBreakoutIncentives =
      this.type === "vdp"
        ? window.conditionalRebatesBreakoutIncentivesForVDP
        : window.conditionalRebatesBreakoutIncentives;
    let incentiveData =
      this.qualifiedData && typeof this.qualifiedData === "string"
        ? JSON.parse(this.qualifiedData)
        : this.qualifiedData;
    if (incentiveData && incentiveData.length) {
      const lowerize = (obj) =>
        Object.keys(obj).reduce((acc, k) => {
          acc[k.toLowerCase()] = obj[k];
          return acc;
        }, {});
      incentiveData = incentiveData.map((t) => {
        return { ...lowerize(t) };
      });
      this.formatIncentiveData(incentiveData);
    }
    this.finalPriceValue = +this.pricedata?.yourPrice
      ? +this.pricedata?.yourPrice - this.totalIncentive
      : 0;
  },
  methods: {
    getThemeName() {
      if (window.themeName) {
        if (isFordDealer(window.themeName)) return "ford";
        else if (window.themeName.toLowerCase().includes("mazda")) return "mazda";
        else if (window.themeName.toLowerCase().includes("bmw")) return "BMW";
        else if (
          window.themeName.toLowerCase() === "dealergroup_black" ||
          window.themeName.toLowerCase() === "dealergroup_quickcars"
        )
          return "";
        else if (window.themeName.toLowerCase() === "chrysler_dodge_jeep_ram")
          return "Chrysler Jeep Dodge RAM";
        else return window.themeName.toLowerCase();
      } else return "";
    },

    convertThousandSeperator(val) {
      const { Thousandseperator } = useThousandseperator();
      return Thousandseperator(val);
    },

    formatIncentiveData(data) {
      console.log(isFordDealer(window.IncentiveSource), "isFordDealer");
      const incentives = data.map((t) => {
        let cashValue = isFordDealer(window.IncentiveSource) ? +t.amount : +t.cash;
        return {
          ...t,
          programname: isFordDealer(window.IncentiveSource) ? t.namedetailed : t.specialprogramname,
          cash: cashValue,
          incentiveid: isFordDealer(window.IncentiveSource)
            ? t.incentiveid
            : t.specialprogramname + t.offertype,
        };
      });
      if (isFdLincolnDealer(window.IncentiveSource)) {
        this.incentives = incentives.filter(
          (i) =>
            i.offertype.toLowerCase() === "all" ||
            i.offertype.toLowerCase() === this.paymentType.toLowerCase()
        );
      } else {
        this.incentives = incentives;
      }
      //showing incentives in descending order
      this.incentives = this.incentives.sort((a, b) => {
        return b.cash - a.cash;
      });
    },

    showIncentiveDisclaimer(disclaimerName) {
      return disclaimerName === "Military" || disclaimerName === "College Graduate";
    },

    navigateTo(disclaimerName) {
      const link = this.getIncentiveLink(disclaimerName);
      if (link) {
        window.location.href = link;
      }
    },

    getIncentiveLink(disclaimerName) {
      let link = "";
      if (disclaimerName === "Military") {
        link = "/military-rebate-program";
      }
      if (disclaimerName === "College Graduate") {
        link = "/college-grad-rebate";
      }

      return link;
    },

    showFodIncentiveDisclaimerModel(data) {
      if (this.type !== "srp") {
        this.disclaimer = data.disclaimer + (data.stopdate ? ` Expires: ${data.stopdate}` : "");
        this.text = this.disclaimer;
        this.showTextModal = true;
      } else {
        store.commit("showRebatesDisclaimerModel", {
          disclaimer: data.disclaimer,
          showModal: true,
        });
      }
    },
    hideDisclaimer() {
      if (this.type !== "srp") {
        this.showTextModal = false;
      } else {
        store.commit("showRebatesDisclaimerModel", {
          disclaimer: "",
          showModal: false,
        });
      }
    },
    getFontColorForLabel() {
      return this.srpcolor;
    },

    getConditionalLabelStyles() {
      let color = "";
      let fontSize = "16px";
      const lastBlock = document.getElementsByClassName("last-msrp-block");
      const leaseFinalPrice = document.getElementsByClassName("lease-price-details");
      if (lastBlock?.length && lastBlock[0]) {
        let finalPriceDivStyles = this.getFinalPriceDiv()
        color = finalPriceDivStyles.color || '';
        fontSize = finalPriceDivStyles.fontSize || '16px';
      } else if (leaseFinalPrice?.length && window.getComputedStyle) {
        let styles = window.getComputedStyle(leaseFinalPrice[0]);
        color = styles?.color ? styles?.color : "";
        fontSize = styles?.fontSize ? styles?.fontSize : "16px";
      } else {
        //No action needed for other cases
      }

      return { color: color, "font-size": fontSize };
    },

    getFinalPriceDiv() {
      let finalPriceDiv = lastBlock[0].querySelector(".msrp-text");
      if (finalPriceDiv && window.getComputedStyle) {
        let styles = window.getComputedStyle(finalPriceDiv);
        return {
          color: styles?.color ? styles?.color : "",
          fontSize: styles?.fontSize ? styles?.fontSize : "16px",
        };
      }
    },

    onClickConditionalOffers() {
      if (window.ismobile || window.istablet) {
        this.showConditionalOffers = !this.showConditionalOffers;
      }
    },
  },
};
</script>

<style scoped>
.incentiveBlockTooltipCond {
  cursor: pointer;
  position: relative;
}

.incentiveBlockTooltipCond .tooltip {
  display: block;
  position: absolute;
  left: 6px;
  bottom: 2.75em;
  transform: translateX(-50%);
  width: max-content;
  border-radius: 0.25em;
  padding: 0.5em;
  background-color: rgba(0, 0, 0, 1.55);
  backdrop-filter: blur(2px) invert(80%);
  color: #eee;
  font-size: 0.8em;
  opacity: 0;
  scale: 0;
  transition: opacity, scale 0.3s;
  transform-origin: left bottom;
  max-width: 260px;
  z-index: 99;
  min-width: 260px;
}

.ft-22 {
  font-size: 22px;
}

.incentiveBlockTooltipCond .tooltip::before {
  content: "";
  position: absolute;
  left: 130px;
  bottom: -0.35em;
  transform: translateX(-50%);
  border: 0.35em solid rgba(0, 0, 0, 0);
  border-top-color: #000;
  border-bottom-width: 0;
}

.incentiveBlockTooltipCond:hover .tooltip {
  opacity: 1;
  scale: 1;
}

.incentiveBlockTooltipCond .tooltip ul {
  padding: 10px;
  margin: 0;
  list-style: none;
}

.incentiveBlockTooltipCond .tooltip ul li {
  display: flex;
  justify-content: space-between;
  width: 100% !important;
  align-items: end;
  word-break: break-all;
  border-bottom: 1px solid #4f4f4f;
}

.incentiveBlockTooltipCond .tooltip ul li span {
  padding: 2px 5px;
}

.incentiveBlockTooltipCond .tooltip ul li span:nth-child(1) {
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  word-break: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.incentiveBlockTooltipCond .tooltip ul li span:nth-child(2) {
  min-width: 50px;
  padding: 2px;
  text-align: right;
}

.fright {
  float: right;
}

.fright:after {
  content: "";
  clear: both;
  display: table;
}

.payment .price-value {
  float: right;
}

.payment.ford .price-value {
  float: none;
}

.incentive-popover-parent {
  position: relative;
}

.incentive-popover-class {
  display: none;
  position: absolute;
  width: 215px;
  z-index: 1;
  background: white;
  padding: 12px;
  border: 1px solid #dee2e6 !important;
  border-radius: 5px;
  left: 50%;
  transform: translateX(-50%);
  top: 29px;
}

.incentive-popover-class-down-icon {
  display: none;
  border-color: rgba(0, 0, 0, 0);
}

.incentive-popover-parent:hover .incentive-popover-class,
.incentive-popover-parent:focus .incentive-popover-class,
.incentive-popover-parent:hover .incentive-popover-class-down-icon,
.incentive-popover-parent:focus .incentive-popover-class-down-icon {
  display: block;
}

.ford-incentives {
  font-size: 12px;
  margin: 8px 0;
  line-height: 18px;
  align-items: center;
}
</style>
